import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../data/store'
import { getNetworkResponseError, getUTCTimeStamp, isStatusOK } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { apiConfig } from './config'
import { sendEventApiScheduled } from './sendEvent'

const responseParser = (data: any) => {
  if (isStatusOK(data) && data?.data?.responseCode === '00') {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

export const getBankList = (tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.getBankList,
    //apiPath: 'http://10.162.6.163:9012/jpb/v1/aeps/common/banks',
    method: 'POST',
    config: apiConfig(tokens),
    body: getBankListRequest(),
  }
  sendEventApiScheduled(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApiScheduled(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApiScheduled(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}

const getBankListRequest = () => {
  return {
    initiatingEntity: {
      entityId: RootStore?.agent?.session?.CHANNEL_ID,
      initiatingEntityTimestamp: getUTCTimeStamp(),
      version: 'v2',
    },
  }
}
